import { Directive, Input, OnInit, inject } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';
import { Gtm } from '../../gtm.namespace';
import { GtmService } from '../../gtm.service';

@Directive()
export abstract class GtmTrackViewItemListAbstract implements OnInit {
    @Input()
    gtmTrackViewItemList!: Gtm.ITrackViewItemList;

    @Input()
    gtmTrackViewItemListOff?: boolean;

    protected meta = inject(Meta);
    protected timeoutService = inject(TimeoutService);
    protected subscriptions = new Subscription();

    constructor(protected gtmService: GtmService) {}

    ngOnInit() {
        this.trackViewItemList();

        this.subscriptions.add(this.meta.subscribe(() => this.trackViewItemList()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected get eventData() {
        const data = this.gtmTrackViewItemList;
        const items = this.gtmService.getEcommerceItems(data.models);
        const listId = `${data.listId}`.trim();
        const listName = `${data.listName}`.trim();

        const eventData: Gtm.IEventViewItemListData = {
            items: items.map(item => {
                const itemData = {
                    ...item
                };

                if (data.listId) {
                    itemData.item_list_id = listId;
                }

                if (data.listName) {
                    itemData.item_list_name = listName;
                }

                return itemData;
            })
        };

        if (data.listId) {
            eventData.item_list_id = listId;
        }

        if (data.listName) {
            eventData.item_list_name = listName;
        }

        return eventData;
    }

    protected trackViewItemList() {
        this.timeoutService.setTimeout(() => {
            if (!this.gtmTrackViewItemListOff) {
                this.gtmService.trackViewItemList(this.eventData);
            }
        }, 100);
    }
}
